// extracted by mini-css-extract-plugin
export default {"mobile-wrapper":"mobile-wrapper--kumUa","mobile-wrapper-list-view":"mobile-wrapper-list-view--ELgnj"};